import Model from '@/models/mobile'

export default {
    namespaced:true,
    state:{
        data:{},
        carin:{}
    },
    getters:{
        getData(state){
            return state.data
        },
        getCarin(state){
            return state.carin
        }
    },
    mutations:{
        setData(state,data){
            state.data=data.list;
        },
        setCarin(state,data){
            state.carin=data
        }
    },
    actions:{
        async setDataAction({commit},payload){
            let {data} = await Model.sendCar(payload)
            return new Promise((resolve,reject) => {
                if(data.success){
                    commit('setData',data);
                    resolve()
                }else{
                    reject()
                }
            })
        },
        async setCarinAction({commit},payload){
            let {data} = await Model.getCarin(payload)
            return new Promise((resolve,reject) => {
                if(data.success){
                    commit('setCarin',data)
                    resolve()
                }else{
                    reject()
                }
            })
        },
        async setCarinBranchAction({commit},payload){
            let {data} = await Model.getCarinBranch(payload)
            return new Promise((resolve,reject) => {
                if(data.success){
                    commit('setCarin',data);
                    resolve()
                }else{
                    reject()
                }
            })
        },
        async setCarinByMsgAction({commit},payload) {
            let { data } = await Model.getCarinByMsg(payload)
            return new Promise((resolve,reject) => {
                if(data.success){
                    commit('setData',{list:data})
                    resolve(data)
                }else{
                    reject()
                }
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/mobile.js